<template>
  <d-modal @close="handleClose" size="lg">
    <d-modal-header>
        <d-modal-title>
            {{ $t('order.nameCheck.popup.title') }}
        </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
        <table class="table mt-0 mb-0 full-width">
            <thead class="bg-light">
            <tr>
                <th scope="col" class="border-0 text-center pl-4" style="width: 50px;">{{ $t('order.nameCheck.popup.id') }}</th>
                <th scope="col" class="border-0" style="width: 200px;">{{ $t('order.nameCheck.popup.status') }}</th>
                <th scope="col" class="border-0">{{ $t('order.nameCheck.popup.name') }}</th>
                <th scope="col" class="border-0 text-center" style="width: 150px;">{{ $t('order.nameCheck.popup.lastModified') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(itemData, index) of ordersData"
                :key="'orders-data-' + index">
                <td class="align-middle text-center pl-4">
                    {{ itemData.id }}
                </td>
                <td class="align-middle">
                    <d-badge
                        :theme="getStatusClass(itemData.status)"
                        :outline="getOutline(itemData.status)">
                        {{ getStatusName(itemData.status) }}
                    </d-badge>
                </td>
                <td class="align-middle">
                    {{ itemData.order_name }}
                </td>
                <td class="align-middle text-center">
                    {{ itemData.updated_at.split('T')[0] }}
                </td>
            </tr>
            </tbody>
        </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
import ListUtils from './../../utils/ListUtils';
import orderStatuses from './../../data/order-statuses.js';
import orderStatusClasses from './../../data/order-status-classes.js';

export default {
  name: 'order-name-popup',
  props: [
    'ordersData'
  ],
  methods: {
    handleClose () {
      this.$bus.$emit('close-order-name-popup');
    },
    cancel () {
      this.handleClose();
    },
    getStatusName (status) {
      return ListUtils.getKeyLabel(orderStatuses[this.$i18n.locale], status);
    },
    getStatusClass (status) {
      return ListUtils.getKeyLabel(orderStatusClasses, status).replace(' outline', '');
    },
    getOutline (status) {
      return ListUtils.getKeyLabel(orderStatusClasses, status).indexOf(' outline') > -1;
    }
  }
}
</script>
